import { na1 } from 'hubspot-url-utils/hublets';
import reportError from 'ui-forms-embed-components-reporting/reporting/reportError';
const reportErrorToLogFetch = ({
  formId = '',
  portalId = '',
  hublet = na1,
  isQa = false,
  key,
  error = '',
  data = {},
  module = 'ui-forms-embed-components-modules'
}) => {
  const formInfo = {
    formId,
    portalId,
    env: isQa ? 'qa' : 'prod',
    hublet,
    pageUrl: window.location.href
  };
  const projectInfo = {
    renderVersion: '1',
    projectVersion: '1',
    module
  };
  const errorInfo = {
    key,
    error,
    data: data.response && data.response.data ? data.response.data : data
  };
  reportError(formInfo, projectInfo, errorInfo);
};
export default reportErrorToLogFetch;